<template>
    <form-input-layout :help-item-code="helpItemCode" :active="active">
        <template slot="caption">
            {{ caption }}<strong v-if="required" class="required">*</strong>
        </template>
        <template slot="input">
            <div style="display: flex; flex-flow: row; align-items: center;">

                <v-date-picker
                    v-model="pickerValue"
                    :attributes="dateAttributes"
                    color="red"
                    @input="handleCalendarInput"
                    :popover="{visibility: 'click', placement: 'bottom'}">
                    <template v-slot="{ inputValue, inputEvents }">
                        <icon v-on="inputEvents" :icon="['fal', 'calendar']"/>
                    </template>
                </v-date-picker>


                <input v-bind:value="internalValue" placeholder="<no date>" type="text"
                       :class="{ 'input-component': true, 'active': active}"
                       @input="pipeInput"
                       @keyup.enter="validateAndOutput"
                       @blur="onBlur"
                       @focus="toggleActive"/>
            </div>
        </template>
    </form-input-layout>
</template>

<script>
import FormInputLayout from "./FormInputLayout";
import {Vue} from "vue";
import FormInputMixin from "./FormInputMixin";

export default {
    name: "FormDateExpressionInput",
    components: {FormInputLayout},
    props: {
        value: String,
        caption: String,
        disabled: Boolean,
        required: Boolean,
        helpItemCode: String
    },
    data: function () {
        return {
            internalValue: "",
            finalValue: "",
            active: false,
            pickerValue: null,
            dateAttributes: [
                {
                    key: 'today',
                    highlight: {
                        style: {
                            borderColor: '#c84a4b', //accent-color
                            borderWidth: '2px',
                            borderStyle: 'solid',
                        },

                    },
                    dates: new Date(),
                    order: 100
                },
            ],
        }
    },
    methods: {
        handleCalendarInput(input) {
            const parsedDate = this.$formats.formatDate(
                (input.getYear() + 1900) + "-" + (input.getMonth() + 1) + "-" + input.getDate() + "T00:00:00", false);
            if (parsedDate != this.internalValue) {
                this.internalValue = this.$formats.formatDate(
                    (input.getYear() + 1900) + "-" + (input.getMonth() + 1) + "-" + input.getDate() + "T00:00:00", false);
                this.validateAndOutput();
            }

        },
        onBlur() {
            this.toggleActive();
            this.validateAndOutput();
        },
        toggleActive() {
            this.active = !this.active;
        },
        pipeInput($event) {
            this.internalValue = $event.target.value;
        },
        validateAndOutput() {
            if (this.$formats.parseDate(this.internalValue) == 'Invalid date') {
                this.$emit("input", this.internalValue);
            } else {
                this.$emit("input", this.$formats.parseDate(this.internalValue));
            }
        }
    },
    watch: {
        value: {
            handler(newValue) {
                if (newValue == "" || newValue == null) {
                    this.internalValue = "";
                } else {
                    if (this.$formats.formatDate(newValue) == 'Invalid date') {
                        this.internalValue = newValue;
                    } else {
                        this.internalValue = this.$formats.formatDate(newValue);
                    }

                }
            },
            immediate: true
        }
    }
}

</script>

<style lang="scss" scoped>
@import "../../styles/global";

.input-component {
    background-color: transparent;
    border: none;
    border-bottom: 1px solid var(--input-border-color);
    background-color: var(--input-background-color);
    border-radius: 5px;
    color: var(--input-font-color);
    padding: 2px 10px 2px 10px;
    outline: none;
    width: 100%;
    font-family: Source Sans Pro;
    margin-left: 10px;
}

.active {
    color: var(--input-active-font-color);
    background-color: var(--input-active-background-color);
    border: 1px solid var(--input-active-border-color);
}

.required {
    color: var(--accent-color);
}

</style>